// extracted by mini-css-extract-plugin
export default {"comment-indicator":"ContentCell-module__comment-indicator__RkpILjY","in-progress-comment-indicator":"ContentCell-module__in-progress-comment-indicator__M8k8BhX"};